var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.me)?_c('div',{staticClass:"the-navbar__user-meta flex items-center"},[_c('router-link',{staticClass:"consultant-image-file-link",attrs:{"to":{
      name: 'consultant.edit',
      params: { id: _vm.me.consultant.id }
    }}},[_c('MeImage',{attrs:{"src":_vm.me.consultant.imageID}})],1),_c('button',{staticClass:"logout-button cursor-pointer",attrs:{"title":"Logout"},on:{"click":_vm.logout}},[_c('feather-icon',{attrs:{"icon":['fal', 'sign-out']}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }